import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useAdvisoryNeeds } from '../../api';
import { AdminContentScreen, AdvisoryNeedEditor } from '../../components/admin';
import { useNumberSearchParams } from '../../hooks/useNumberSearchParams';
import { AVAILABLE_LANGUAGES } from '../../i18n/i18nextInit';
import type { AdvisoryNeedDto } from '../../interfaces/advisory-need';

const emptyNeed: AdvisoryNeedDto = {
    id: -1,
    name: AVAILABLE_LANGUAGES.reduce((acc, lang) => ({ ...acc, [lang]: '' }), {}),
    description: AVAILABLE_LANGUAGES.reduce((acc, lang) => ({ ...acc, [lang]: '' }), {}),
    proposedActions: AVAILABLE_LANGUAGES.reduce((acc, lang) => ({ ...acc, [lang]: '' }), {}),
    checkListIds: [],
    knowHowIds: [],
    toolIds: [],
    includedDomiciles: [],
    excludedDomiciles: [],
    global: false,
};

export const AdminAdvisoryNeeds: FunctionComponent = () => {
    const { data: advisoryNeeds } = useAdvisoryNeeds();

    const [advisoryNeedId, setSearchParams] = useNumberSearchParams('adv-need');
    const displayedItem = useMemo(
        () => (advisoryNeedId != null ? advisoryNeeds?.find((need) => need.id === advisoryNeedId) || emptyNeed : undefined),
        [advisoryNeedId, advisoryNeeds],
    );

    const goToAdvisoryNeed = (needId: number) => setSearchParams({ 'adv-need': needId.toString() });

    return (
        <AdminContentScreen
            items={advisoryNeeds}
            displayedItem={displayedItem}
            onCreateClick={() => goToAdvisoryNeed(-1)}
            onItemClick={goToAdvisoryNeed}
            itemEditorComponent={<AdvisoryNeedEditor need={displayedItem} key={advisoryNeedId} />}
        />
    );
};
